declare namespace $ {

	type $bog_ui_toast__message_bog_ui_toast_manager_1 = $mol_type_enforce<
		ReturnType< $bog_ui_toast_manager['toast_message'] >
		,
		ReturnType< $bog_ui_toast['message'] >
	>
	type $bog_ui_toast__type_bog_ui_toast_manager_2 = $mol_type_enforce<
		ReturnType< $bog_ui_toast_manager['toast_type'] >
		,
		ReturnType< $bog_ui_toast['type'] >
	>
	type $bog_ui_toast__close_bog_ui_toast_manager_3 = $mol_type_enforce<
		ReturnType< $bog_ui_toast_manager['toast_close'] >
		,
		ReturnType< $bog_ui_toast['close'] >
	>
	export class $bog_ui_toast_manager extends $mol_view {
		toast_message( id: any): string
		toast_type( id: any): string
		toast_close( id: any, next?: any ): any
		toast_views( ): readonly(any)[]
		toast_data( ): readonly(any)[]
		Toast( id: any): $bog_ui_toast
		sub( ): ReturnType< $bog_ui_toast_manager['toast_views'] >
	}
	
}

//# sourceMappingURL=manager.view.tree.d.ts.map